export default function NewStatus (): JSX.Element {
  return (
    <div>
      <h1>Status</h1>
      <p>This page is currently under maintenance. We are sorry for the temporary inconvenience.</p>
    </div>
  )
}
